import Vue from 'vue'
import Router from 'vue-router'
import Login from "../UserViews/Login";
import signUp from "../UserViews/SignUp";
import dashboard from "../UserViews/Dashboard";
import adminDashboard from "../AdminViews/AdminDashboard";
import adminLogin from "../AdminViews/AdminLogin";
import editUserDetails from "../components/EditUserDetails";

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '',
      name: 'Login',
      component: Login
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: signUp
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: dashboard
    },
    {
      path: '/admindashboard',
      name: 'AdminDashboard',
      component: adminDashboard
    },
    {
      path: '/adminLogin',
      name: 'AdminLogin',
      component: adminLogin
    },
    {
      path: '/edit',
      name: 'EditUserDetails',
      component: editUserDetails
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/router.js